
























































































import { Component, Vue } from "vue-property-decorator";
import * as util from "@/util";
import {
  domain,
  Branch,
  Company,
  EditPermission,
  EditUser,
  PERMISSION_ATTRS,
  SPECIAL_PERMISSION_ATTRS,
  User,
  VueRoot,
  ClientUser
} from "@/domain";
import DatePicker from "@/components/DatePicker.vue";
import * as excel from "@/util/excel";

interface ExcelRow {
  email: string;
  userName?: string;
  password?: string;
  branchClientID?: string;
  allowTxnStatistics?: string;
  allowConnectionGraph?: string;
  txnView?: string;
}

interface UserRow {
  email: string;
  userName?: string;
  password?: string;
  company: Company;
  branch?: Branch;
  allowTxnStatistics?: boolean;
  allowConnectionGraph?: boolean;
  txnView?: boolean;
}

@Component({
  components: { DatePicker }
})
export default class UserImportDialog extends Vue {
  isLoading = false;
  dialog = false;
  records: UserRow[] = [];
  failedCount = 0;
  saved: ClientUser[] = [];

  get lang() {
    return this.$store.state.lang.data;
  }

  get currentCompany(): Company | null {
    if (this.$store.state.selectedCompanyLoading) {
      return null;
    }
    return this.$store.state.selectedCompany;
  }

  get userCompanies(): Company[] {
    if (!this.$store.state.userCompanies) {
      return [];
    }
    return this.$store.state.userCompanies;
  }

  get currentUser(): User {
    return this.$store.state.currentUser || {};
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  snackShow(message: string, color: string) {
    this.$emit("message", { message, color });
  }

  close() {
    this.dialog = false;
  }

  get tableHeaders() {
    return [
      { text: "Email", value: "email", sortable: false },
      { text: "Nombre", value: "userName", sortable: false },
      { text: "Password", value: "password", sortable: false },
      { text: "Comercio", value: "company", sortable: false },
      { text: "Oficina", value: "branch", sortable: false },
      { text: "Permiso: TXN Estadísticas", value: "allowTxnStatistics", sortable: false },
      { text: "Permiso: Terminales", value: "allowConnectionGraph", sortable: false },
      { text: "Permiso: TXN View", value: "txnView", sortable: false }
    ];
  }

  get tableSavedHeaders() {
    return [
      { text: "UID", value: "uid", sortable: false },
      { text: "Email", value: "email", sortable: false },
      { text: "Nombre", value: "displayName", sortable: false },
      { text: "Creado el", value: "creationTimeUTC", sortable: false }
    ];
  }

  async cmdImportUsers() {
    this.isLoading = true;
    this.failedCount = 0;
    const failed: UserRow[] = [];
    for (const row of this.records) {
      try {
        const result = await this.saveUser(row);
        if (result == null || !result.success) {
          failed.push(row);
        } else {
          this.saved.push(result.user);
        }
      } catch (err) {
        util.logError("Error saving user", { row, err });
        failed.push(row);
      }
    }
    this.records = failed;
    this.failedCount = failed.length;
    this.isLoading = false;
  }

  async saveUser(row: UserRow) {
    const permission: EditPermission = {
      companyID: row.company.id,
      remove: false,
      admin: false,
      branchIDs: row.branch ? [row.branch.id] : []
    };
    PERMISSION_ATTRS.filter((attr) => !SPECIAL_PERMISSION_ATTRS.includes(attr)).forEach(
      (attr) => (permission[attr] = !!row[attr as keyof UserRow])
    );

    const user: EditUser = {
      edit: false,
      uid: "",
      isImport: true,
      permissions: [permission],
      accountChanges: {
        email: row.email,
        displayName: row.userName,
        emailVerified: false
      }
    };
    if (row.password && user.accountChanges) {
      user.accountChanges.password = row.password;
    }
    try {
      const savedResult = await domain.backend.saveUser(user);
      util.log("Usuario guardado", user, savedResult);
      if (!user.accountChanges?.password && savedResult.isNewAccount) {
        await domain.backend.resetPassword(savedResult.user.email);
        this.snackShow("¡Usuario Guardado con éxito! Email de contraseña enviado.", "success");
      } else {
        this.snackShow("¡Usuario Guardado con éxito! Refrescando lista.", "success");
      }
      return savedResult;
    } catch (error) {
      util.logError("Error guardando el usuario", error);
      return null;
    }
  }

  cmdDownloadTemplate() {
    const headerIds = [
      "email",
      "userName",
      "password",
      "branchClientID",
      "allowTxnStatistics",
      "allowConnectionGraph",
      "txnView"
    ];
    const headers = headerIds.map((fldValue) => excel.header(fldValue, fldValue, 25));
    return excel.writeSpreadsheet("UserImport.xlsx", "Users", headers, []);
  }

  async onExcelImport(files: File[]) {
    try {
      if (!this.currentCompany) {
        this.snackShow("Seleccione un comercio", "red");
        return;
      }
      if (files && files.length > 0) {
        const sheet = await excel.readSpreasheet(files[0], true);
        util.log("ExcelData", sheet);
        this.records = (sheet.rows as unknown as ExcelRow[]).map((r) => this.mapRow(r));
      }
    } catch (e) {
      util.logError("Error loading excel", e);
      this.snackShow("Error leyendo el archivo " + e, "red");
    }
  }

  mapRow(row: ExcelRow): UserRow {
    if (!this.currentCompany) throw new Error("Comercio no seleccionado");
    return {
      email: row.email,
      userName: row.userName,
      password: row.password,
      company: this.currentCompany,
      branch: this.currentCompany?.branches?.find(
        (b) =>
          !!row.branchClientID &&
          !!b.customerID &&
          b.customerID.toString().trim() === row.branchClientID.toString().trim()
      ),
      allowTxnStatistics: util.toBoolOrNull(row.allowTxnStatistics) || false,
      allowConnectionGraph: util.toBoolOrNull(row.allowConnectionGraph) || false,
      txnView: util.toBoolOrNull(row.txnView) || false
    };
  }

  // ------ PUBLIC Methods ------- //
  open() {
    this.records = [];
    this.dialog = true;
  }
  // ------ PUBLIC Methods ------- //
}
